module.exports = __webpack_public_path__ + "img/elementwidths_jasp.e58771c3.png";